import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { findUser, modifyUser, findSetting, updateAlertSetting, listDevice, updateTermSetting } from '../_actions/user_action';

import '../css/Header.css';
import '../css/Body.css';

import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';

// 콤보박스추가
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';

// Modal import
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

// 주소검색 - 다음
import Post from "./Post";
import { getUserAccount, getIsLogin, clearSession } from '../utils/session';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

// Modal
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 600,
    bgcolor: 'background.paper',
    borderRadius: '16px',
    border: 'none',
    boxShadow: 14,
    p: 4
};

function Setting() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userAccount = getUserAccount() || {};
    const isLogin = getIsLogin();

    const onLogoutHandler = (event) => {
        event.preventDefault();
        clearSession();
        window.location.replace('/');
    };

    const [isReady, setIsReady] = useState(false);
    const [userInfo, setUserInfo] = useState();
    const [settingInfo, setSettingInfo] = useState();

    useEffect(() => {
        if (!isLogin || !userAccount) {
            navigate('/Login');
            return;
        }

        let body = {
            email: userAccount.email
        };

        dispatch(findUser(body)).then(response => {
            // console.log('findUser', response.payload);
            
            if (response.payload.findSuccess) {
                let userInfo = response.payload.userInfo;
                if (userInfo) {
                    setUserInfo(userInfo);

                    body = {
                        id: userAccount.email,
                        sensorMain: userAccount.sensorMain
                    };
    
                    dispatch(findSetting(body)).then(response => {
                        console.log('findSetting', response.payload);

                        if (response.payload.findSuccess) {
                            let settingInfo = response.payload.settingInfo;
                            if (settingInfo) {
                                setSettingInfo(settingInfo);
                                if (settingInfo.opLightLampNH3 === 1) {
                                    setCheckedLightLampNH3(true);
                                }
                                if (settingInfo.opSNSPushNH3 === 1) {
                                    setCheckedSNSPushNH3(true);
                                }
                                if (settingInfo.opLightLampH2S === 1) {
                                    setCheckedLightLampH2S(true);
                                }
                                if (settingInfo.opSNSPushH2S === 1) {
                                    setCheckedSNSPushH2S(true);
                                }
                                setInputsModifyAlert({
                                    modifyMoeLimitNH3: settingInfo.moeLimitNH3,
                                    modifyUserLimitNH3: settingInfo.userLimitNH3.length === 0 ? settingInfo.moeLimitNH3 : settingInfo.userLimitNH3,
                                    modifyOpLightLampNH3: settingInfo.opLightLampNH3,
                                    modifyOpSNSPushNH3: settingInfo.opSNSPushNH3,
                                    modifyMoeLimitH2S: settingInfo.moeLimitH2S,
                                    modifyUserLimitH2S: settingInfo.userLimitH2S.length === 0 ? settingInfo.moeLimitH2S : settingInfo.userLimitH2S,
                                    modifyOpLightLampH2S: settingInfo.opLightLampH2S,
                                    modifyOpSNSPushH2S: settingInfo.opSNSPushH2S
                                });
                                setModifyUserTerm(settingInfo.userTerm);
                                setIsReady(true);
                            }
                        }
                    })
                    .catch((err) => console.log(err));
                }
            }
        })
        .catch((err) => console.log(err));
    }, []);

    // 기본정보 설정  Set default information - 수정
    const focusRefModifyUserCompany = useRef();
    const focusRefModifyUserAddress = useRef();
    const focusRefModifyUserAddressDetail = useRef();
    const focusRefModifyUserTel = useRef();
    const focusRefModifyUserChargeName = useRef();
    const focusRefModifyUserCellPhone1 = useRef();

    const [inputsModify, setInputsModify] = useState({
        modifyUserCompany: "",
        modifyUserAddress: "",
        modifyUserAddressDetail: "",
        modifyUserPostal: "",
        modifyUserLatitude: "",
        modifyUserLongitude: "",
        modifyUserTel: "",
        modifyUserChargeName: "",
        modifyUserCellPhone1: "",
        modifyUserCellPhone2: ""
    });

    const {
        modifyUserCompany,
        modifyUserAddress,
        modifyUserAddressDetail,
        modifyUserTel,
        modifyUserChargeName,
        modifyUserCellPhone1,
        modifyUserCellPhone2
    } = inputsModify;

    const handleChangeModify = (e) => {
        console.log(e.target.name, e.target.value);

        let regex = /^[0-9\b -]{0,13}$/;
        if (e.target.name === 'modifyUserTel') {
            if (!regex.test(e.target.value))
                return;
        }
        regex = /^[0-9\b -]{0,13}$/;
        if (e.target.name === 'modifyUserCellPhone1' || e.target.name === 'modifyUserCellPhone2') {
            if (!regex.test(e.target.value))
                return;
        }

        const { value, name } = e.target;
        setInputsModify({
            ...inputsModify,
            [name]: value
        });
    };

    useEffect(() => {
        let replaceUserPhone = '';
        // 전화번호
        if (modifyUserTel.length === 10) {
            replaceUserPhone = modifyUserTel.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserTel: replaceUserPhone
            });
        }
        if (modifyUserTel.length === 12) {
            replaceUserPhone = modifyUserTel.replace(/-/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserTel: replaceUserPhone
            });
        }
        if (modifyUserTel.length === 13) {
            replaceUserPhone = modifyUserTel.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserTel: replaceUserPhone
            });
        }
        // 휴대폰 1
        if (modifyUserCellPhone1.length === 10) {
            replaceUserPhone = modifyUserCellPhone1.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserCellPhone1: replaceUserPhone
            });
        }
        if (modifyUserCellPhone1.length === 13) {
            replaceUserPhone = modifyUserCellPhone1.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserCellPhone1: replaceUserPhone
            });
        }
        // 휴대폰 2
        if (modifyUserCellPhone2.length === 10) {
            replaceUserPhone = modifyUserCellPhone2.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserCellPhone2: replaceUserPhone
            });
        }
        if (modifyUserCellPhone2.length === 13) {
            replaceUserPhone = modifyUserCellPhone2.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserCellPhone2: replaceUserPhone
            });
        }
    }, [inputsModify, modifyUserTel, modifyUserCellPhone1, modifyUserCellPhone2]);

    // 기본정보 설정 수정 Modal
    const [modifyOpen, setModifyOpen] = useState(false);
    const handleModifyOpen = (e) => {
        setEnroll_address({
            ...enroll_address,
            address: userInfo.address,
            postal: userInfo.postal,
            latitude: userInfo.latitude,
            longitude: userInfo.longitude
        });
        setInputsModify({
            modifyUserCompany: userInfo.company,
            modifyUserTel: userInfo.tel,
            modifyUserAddress: userInfo.address,
            modifyUserAddressDetail: userInfo.addressDetail,
            modifyUserPostal: userInfo.postal,
            modifyUserLatitude: userInfo.latitude,
            modifyUserLongitude: userInfo.longitude,
            modifyUserChargeName: userInfo.chargeName,
            modifyUserCellPhone1: userInfo.cellPhone1,
            modifyUserCellPhone2: userInfo.cellPhone2
        });
        setModifyOpen(true);
    };
    const handleModifyClose = () => setModifyOpen(false);

    // 주소검색
    const [enroll_address, setEnroll_address] = useState({
        address: '',
        postal: '',
        latitude: '',
        longitude: ''
    });

    const [popup, setPopup] = useState(false);

    const handleInput = (e) => {
        setEnroll_address({
            ...enroll_address,
            [e.target.name]: e.target.value
        });
    };

    const handleComplete = (data) => {
        setPopup(!popup);
        console.log('handleComplete', data);
    };

    const handleModifySubmit = (e) => {
        e.preventDefault();
        
        let modify_key = "";
        let modify_errors = "";

        const changeUser = {
            company: modifyUserCompany,
            tel: modifyUserTel,
            address: enroll_address.address, // modifyUserAddress,
            addressDetail: modifyUserAddressDetail,
            chargeName: modifyUserChargeName,
            cellPhone1: modifyUserCellPhone1
        };

        for (var key in changeUser) {
            modify_errors = "";

            if (changeUser[key].length === 0 || changeUser[key] === undefined) {
                modify_key = key;

                if (key === 'company') {
                    modify_errors = "[상호]가 없습니다.";
                } else if (key === 'tel') {
                    modify_errors = "[전화번호]가 없습니다.";
                } else if (key === 'address') {
                    modify_errors = "[주소]가 없습니다. [주소검색]을 이용하여 입력해주세요.";
                } else if (key === 'chargeName') {
                    modify_errors = "[담당자]가 없습니다.";
                } else if (key === 'cellPhone1') {
                    modify_errors = "[휴대폰 1]이 없습니다.";
                } else if (key === 'cellPhone2') {
                    // modify_errors = "[휴대폰 2]가 없습니다."; // 휴대폰 1만 입력해도 된다.
                }
            }

            if (modify_errors.length > 1)
                break;
        }

        if (modify_errors.length > 1) {
            alert(modify_errors);

            if (modify_key === 'company') {
                focusRefModifyUserCompany.current.focus();
            } else if (modify_key === 'tel') {
                focusRefModifyUserTel.current.focus();
            } else if (modify_key === 'address') {
                focusRefModifyUserAddress.current.focus();
            } else if (modify_key === 'chargeName') {
                focusRefModifyUserChargeName.current.focus();
            } else if (modify_key === 'cellPhone1') {
                focusRefModifyUserCellPhone1.current.focus();
            }

            return;
        }

        // 상호
        if (modifyUserCompany.length < 2 || modifyUserCompany.length > 30) {
            modify_errors = "2글자 이상 30글자 미만으로 입력해주세요.";
            alert(modify_errors);
            focusRefModifyUserCompany.current.focus();
            return;
        }

        // 전화번호

        // 주소

        // 담당자
        if (modifyUserChargeName.length < 2 || modifyUserChargeName.length > 30) {
            modify_errors = "2글자 이상 30글자 미만으로 입력해주세요.";
            alert(modify_errors);
            focusRefModifyUserChargeName.current.focus();
            return;
        }

        // 휴대폰 1

        let body = {
            email: userInfo.email,
            company: modifyUserCompany,
            tel: modifyUserTel,
            address: enroll_address.address,
            addressDetail: modifyUserAddressDetail,
            postal: enroll_address.postal,
            latitude: enroll_address.latitude,
            longitude: enroll_address.longitude,
            chargeName: modifyUserChargeName,
            cellPhone1: modifyUserCellPhone1,
            cellPhone2: modifyUserCellPhone2
        };

        let modify_msg = "";

        console.log('findUser', body);
        dispatch(findUser(body)).then(response => {
            if (response.payload.findSuccess) {
                let userInfo = response.payload.userInfo;
                if (userInfo.accountActive === "Y") {
                    console.log('modifyUser', body);
                    dispatch(modifyUser(body)).then(response => {
                        if (response.payload.modifySuccess) {
                            modify_msg = "[" + userInfo.email + " (" + userAccount.company + ")] 기본정보 설정 수정 되었습니다.";
                            alert(modify_msg);
                            window.location.replace('/Setting');
                        }
                    });
                }
            }
        });
    };

    const focusRefModifyMoeLimitNH3 = useRef();
    const focusRefModifyUserLimitNH3 = useRef();
    const focusRefModifyMoeLimitH2S = useRef();
    const focusRefModifyUserLimitH2S = useRef();

    const [inputsModifyAlert, setInputsModifyAlert] = useState({
        modifyMoeLimitNH3: "25",
        modifyUserLimitNH3: "15",
        modifyMoeLimitH2S: "10",
        modifyUserLimitH2S: "6"
    });

    const {
        modifyMoeLimitNH3,
        modifyUserLimitNH3,
        modifyMoeLimitH2S,
        modifyUserLimitH2S
    } = inputsModifyAlert;

    const [checkedLightLampNH3, setCheckedLightLampNH3] = useState(false);
    const [checkedSNSPushNH3, setCheckedSNSPushNH3] = useState(false);
    const [checkedLightLampH2S, setCheckedLightLampH2S] = useState(false);
    const [checkedSNSPushH2S, setCheckedSNSPushH2S] = useState(false);

    const handleChangeModifyAlert = (e) => {
        console.log(e.target.name, e.target.value);

        const regex = /^\d+\.\d{2}$/;
        if (e.target.name === 'modifyMoeLimitNH3' || e.target.name === 'modifyUserLimitNH3' || e.target.name === 'modifyMoeLimitH2S' || e.target.name === 'modifyUserLimitH2S') {
            // if (!regex.test(e.target.value))
                // return;
        }

        const { value, name } = e.target;
        setInputsModifyAlert({
            ...inputsModifyAlert,
            [name]: value
        });
    };

    const handleChange_LightLamp_NH3 = (e) => {
        setCheckedLightLampNH3(e.target.checked);
    };

    const handleChange_SNSPush_NH3 = (e) => {
        setCheckedSNSPushNH3(e.target.checked);
    };
    
    const handleChange_LightLamp_H2S = (e) => {
        setCheckedLightLampH2S(e.target.checked);
    };

    const handleChange_SNSPush_H2S = (e) => {
        setCheckedSNSPushH2S(e.target.checked);
    };

    const handleModifySubmitAlert = (e) => {
        e.preventDefault();
        
        let modify_key = "";
        let modify_errors = "";
    
        const changeAlertSetting = {
            id: settingInfo.id,
            sensorMain: settingInfo.sensorMain,
            moeLimitNH3: modifyMoeLimitNH3,
            moeLimitH2S: modifyMoeLimitH2S,
            userLimitNH3: modifyUserLimitNH3,
            userLimitH2S: modifyUserLimitH2S
        };
    
        for (var key in changeAlertSetting) {
            modify_errors = "";
    
            if (changeAlertSetting[key].length === 0 || changeAlertSetting[key] === undefined) {
                modify_key = key;
    
                if (key === 'moeLimitNH3') {
                    modify_errors = "암모니아 - [환경부 허용치]가 없습니다.";
                } else if (key === 'moeLimitH2S') {
                    modify_errors = "황화수소 - [환경부 허용치]가 없습니다.";
                } else if (key === 'userLimitNH3') {
                    modify_errors = "암모니아 - [사용자 기준치]가 없습니다.";
                } else if (key === 'userLimitH2S') {
                    modify_errors = "황화수소 - [사용자 기준치]가 없습니다.";
                }
            }
    
            if (modify_errors.length > 1)
                break;
        }
    
        if (modify_errors.length > 1) {
            alert(modify_errors);
    
            if (modify_key === 'moeLimitNH3') {
                focusRefModifyMoeLimitNH3.current.focus();
            } else if (modify_key === 'moeLimitH2S') {
                focusRefModifyMoeLimitH2S.current.focus();
            } else if (modify_key === 'userLimitNH3') {
                focusRefModifyUserLimitNH3.current.focus();
            } else if (modify_key === 'userLimitH2S') {
                focusRefModifyUserLimitH2S.current.focus();
            }
    
            return;
        }
    
        // 암모니아
        // 환경부 허용치
        if (!(modifyMoeLimitNH3.length === 2)) {
            modify_errors = "암모니아 - 환경부 허용치 값을 정수 2자리로 정확하게 입력해주세요.";
            alert(modify_errors);
            setInputsModifyAlert({
                ...inputsModifyAlert,
                moeLimitNH3: ""
            });
            focusRefModifyMoeLimitNH3.current.focus();
            return;
        }
        // 사용자 기준치
        if (!(modifyUserLimitNH3.length === 2)) {
            modify_errors = "암모니아 - 사용자 기준치 값을 정수 2자리로 정확하게 입력해주세요.";
            alert(modify_errors);
            setInputsModifyAlert({
                ...inputsModifyAlert,
                userLimitNH3: ""
            });
            focusRefModifyUserLimitNH3.current.focus();
            return;
        }
    
        // 황화수소
        // 환경부 허용치
        if (!(modifyMoeLimitH2S.length === 2)) {
            modify_errors = "황화수소 - 환경부 허용치 값을 정수 2자리로 정확하게 입력해주세요.";
            alert(modify_errors);
            setInputsModifyAlert({
                ...inputsModifyAlert,
                moeLimitH2S: ""
            });
            focusRefModifyMoeLimitH2S.current.focus();
            return;
        }
        // 사용자 기준치
        if (!(modifyUserLimitH2S.length === 2)) {
            modify_errors = "황화수소 - 사용자 기준치 값을 정수 2자리로 정확하게 입력해주세요.";
            alert(modify_errors);
            setInputsModifyAlert({
                ...inputsModifyAlert,
                userLimitH2S: ""
            });
            focusRefModifyUserLimitH2S.current.focus();
            return;
        }
    
        let message = "경고설정을 수정하시겠습니까?";
        if (!window.confirm(message))
            return;
    
        let body = {
            id: settingInfo.id,
            sensorMain: settingInfo.sensorMain,
            moeLimitNH3: modifyMoeLimitNH3,
            moeLimitH2S: modifyMoeLimitH2S,
            userLimitNH3: modifyUserLimitNH3,
            userLimitH2S: modifyUserLimitH2S,
            opLightLampNH3: checkedLightLampNH3 ? 1 : 0,
            opLightLampH2S: checkedLightLampH2S ? 1 : 0,
            opSNSPushNH3: checkedSNSPushNH3 ? 1 : 0,
            opSNSPushH2S: checkedSNSPushH2S ? 1 : 0
        };
    
        let modify_msg = "";
    
        console.log('findSetting', body);
        dispatch(findSetting(body)).then(response => {
            if (response.payload.findSuccess) {
                console.log('updateAlertSetting', body);
                dispatch(updateAlertSetting(body)).then(response => {
                    if (response.payload.updateSuccess) {
                        modify_msg = "[" + settingInfo.id + " (" + userAccount.company + ")] 경고설정 수정 되었습니다.";
                        alert(modify_msg);
                        window.location.replace('/Setting');
                    }
                });
            }
        });
    };

    const [deviceListInfo, setDeviceListInfo] = useState([]);

    useEffect(() => {
        let body = {
            id: userAccount.email
        };
    
        dispatch(listDevice(body)).then(response => {
            if (response.payload.listSuccess) {
                let deviceList = response.payload.deviceList;
                setDeviceListInfo(deviceList);
            }
        });
    }, []);

    const [modifyUserTerm, setModifyUserTerm] = useState(10);

    const handleChangeModifyTerm = (e) => {
        setModifyUserTerm(e.target.value);
    };

    const handleModifySubmitTerm = (e) => {
        let message = "측정 간격 설정을 수정하시겠습니까?";
        if (!window.confirm(message))
            return;

        let body = {
            id: settingInfo.id,
            sensorMain: settingInfo.sensorMain,
            userTerm: modifyUserTerm
        };

        let modify_msg = "";

        console.log('findSetting', body);
        dispatch(findSetting(body)).then(response => {
            if (response.payload.findSuccess) {
                console.log('updateTermSetting', body);
                dispatch(updateTermSetting(body)).then(response => {
                    if (response.payload.updateSuccess) {
                        modify_msg = "[" + settingInfo.id + " (" + userAccount.company + ")] 측정 간격 설정 수정 되었습니다.";
                        alert(modify_msg);
                        window.location.replace('/Setting');
                    }
                });
            }
        });
    };

    return (
        <div className="container">
            <div className="header-wrap">
                <h1>설정</h1>
                <div className="input-seach">
                {/*
                    <input type="text" id="Seach" name="검색" placeholder="검색어를 입력해주세요."/>
                    <FontAwesomeIcon className="seach-icon" icon={faMagnifyingGlass} />
                */}
                </div>
                <div className="info-wrap">
                    <div className="info-id">
                        <span>{userAccount.company}</span>
                        <button className="logout-btn" onClick={onLogoutHandler}>로그아웃</button>
                    </div>
                    <div className="info-email">
                        {userAccount.email}
                    </div>
                </div>
            </div>

            <div className="body-wrap-setting">
                <div className="setting-grop-1">
                {
                    isReady && userInfo &&
                    <>
                    <div className="setting-layout-1">
                        <div className="setting-layout-header">
                            <h3>기본정보 설정</h3> <span>Set default information</span>
                        </div>
                        <div className="settingLayoutBody1">
                            <div className="textInputList">
                                상호
                                <input className="textInput1" type="text" readOnly value={userInfo.company} />
                            </div>
                            <div className="textInputList">
                                주소
                                <input className="textInput1" type="text" readOnly value={userInfo.address} />
                            </div>
                            <div className="textInputList">
                                상세주소
                                <input className="textInput1" type="text" readOnly value={userInfo.addressDetail} />
                            </div>
                            <div className="textInputList">
                                전화번호
                                <input className="textInput1" type="text" readOnly value={userInfo.tel} />
                            </div>
                            <div className="textInputList">
                                담당자
                                <input className="textInput1" type="text" readOnly value={userInfo.chargeName} />
                            </div>
                            <div className="textInputList">
                                휴대폰 1
                                <input className="textInput1" type="text" readOnly value={userInfo.cellPhone1} />
                            </div>
                            <div className="textInputList">
                                휴대폰 2
                                <input className="textInput1" type="text" readOnly value={userInfo.cellPhone2} />
                            </div>
                            <div className="settingLayoutBody1Btn">
                                <Button style={{backgroundColor: '#4e82eb' , borderRadius:'8px' , margin: '0 16px' , padding: '6px 64px', border: 'none' , color:'white'}} 
                                        onClick={handleModifyOpen}
                                        variant="outlined">
                                        수 정
                                </Button>
                            </div>
                        </div>
                    </div>
                    <Modal
                        open={modifyOpen}
                        onClose={handleModifyClose}
                        aria-labelledby="parent-modal-title"
                        aria-describedby="parent-modal-description"
                    >
                        <Box sx={{ ...style, width: 800, height: 700 }}>
                            <Typography className="modalCloseIcon">
                                <CloseIcon onClick={handleModifyClose}/>
                            </Typography>
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                기본정보 수정
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                <div className="ManagementBody">
                                    <div>
                                        <div className="textInputListFull">
                                            <span className="listTitle">아이디</span>                      
                                            <input
                                                value={userInfo.email}
                                                className="textInput7"
                                                type="text"
                                                readOnly />
                                        </div>
                                        <div className="textInputListFull">
                                            <span className="listTitle">상호</span>                      
                                            <input
                                                id="modifyUserCompany"
                                                name="modifyUserCompany"
                                                value={modifyUserCompany}
                                                onChange={handleChangeModify}
                                                required
                                                ref={focusRefModifyUserCompany}
                                                className="textInput7"
                                                type="text"
                                                placeholder="상호를 입력하세요" />
                                        </div>
                                        <div className="textInputListFull">
                                            <span className="listTitle">주소</span>                      
                                            <input
                                                id="address"
                                                name="address"
                                                value={enroll_address.address === '' ? modifyUserAddress : enroll_address.address}
                                                onChange={handleInput}
                                                required
                                                readOnly
                                                className="textInput7"
                                                type="text"
                                                placeholder="주소를 입력하세요" />
                                            <Button style={{backgroundColor: '#F5F6FF', borderRadius:'8px', padding: '12px 32px', border: 'none', color:'#120C0E'}}
                                                    onClick={handleComplete}
                                                    ref={focusRefModifyUserAddress}
                                                    variant="outlined">
                                                    주소검색
                                            </Button>
                                        </div>
                                        <div className="textInputListFull">
                                            <span className="listTitle">상세주소</span>                      
                                            <input
                                                id="modifyUserAddressDetail"
                                                name="modifyUserAddressDetail"
                                                value={modifyUserAddressDetail}
                                                onChange={handleChangeModify}
                                                ref={focusRefModifyUserAddressDetail}
                                                className="textInput7"
                                                type="text"
                                                placeholder="상세주소를 입력하세요" />
                                        </div>
                                        <div className="textInputListFull">
                                            <span className="listTitle">전화번호</span>                      
                                            <input
                                                id="modifyUserTel"
                                                name="modifyUserTel"
                                                value={modifyUserTel}
                                                onChange={handleChangeModify}
                                                required
                                                ref={focusRefModifyUserTel}
                                                className="textInput7"
                                                type="text"
                                                placeholder="전화번호를 입력하세요" />
                                        </div>
                                        <div className="textInputListFull">
                                            <span className="listTitle">담당자</span>                      
                                            <input
                                                id="modifyUserChargeName"
                                                name="modifyUserChargeName"
                                                value={modifyUserChargeName}
                                                onChange={handleChangeModify}
                                                required
                                                ref={focusRefModifyUserChargeName}
                                                className="textInput7"
                                                type="text"
                                                placeholder="담당자 이름을 입력하세요" />
                                        </div>
                                        <div className="textInputListFull">
                                            <span className="listTitle">휴대폰 1</span>                      
                                            <input
                                                id="modifyUserCellPhone1"
                                                name="modifyUserCellPhone1"
                                                value={modifyUserCellPhone1}
                                                onChange={handleChangeModify}
                                                required
                                                ref={focusRefModifyUserCellPhone1}
                                                className="textInput7"
                                                type="text"
                                                placeholder="휴대폰 1을 입력하세요" />
                                        </div>
                                        <div className="textInputListFull">
                                            <span className="listTitle">휴대폰 2</span>                      
                                            <input
                                                id="modifyUserCellPhone2"
                                                name="modifyUserCellPhone2"
                                                value={modifyUserCellPhone2}
                                                onChange={handleChangeModify}
                                                className="textInput7"
                                                type="text"
                                                placeholder="휴대폰 2를 입력하세요" />
                                        </div>                                       
                                        <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 32px', border: 'none', color:'white', fontSize: '16px'}}
                                                onClick={handleModifySubmit}
                                                variant="outlined">
                                                수 정
                                        </Button>
                                        <Button style={{backgroundColor: '#DADADA', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 16px', border: 'none', color:'white', fontSize: '16px'}} 
                                                onClick={handleModifyClose}
                                                variant="outlined">
                                                취 소
                                        </Button>
                                    </div>
                                    {
                                        popup &&
                                        <Post address={enroll_address} setaddress={setEnroll_address} onClose={handleComplete}></Post>
                                    }
                                </div>
                            </Typography>                                 
                        </Box>
                    </Modal>
                    </>
                }
                {
                    isReady && userInfo && settingInfo &&
                    <>
                    <div className="setting-layout-2">
                        <div className="setting-layout-2_1">
                            <div className="setting-layout-header">
                                <h3>경고설정</h3> <span>Alert Settings</span>
                            </div>
                            <div className="settingLayoutBody2">
                                <ul className="realtimeTableTh">
                                    <li>항목</li>
                                    <li>환경부 허용치 (ppm)</li>
                                    <li>사용자 기준치 (ppm)</li>
                                    {/* <li>경광등 작동</li> */}
                                    <li>경고음 발생</li>
                                    <li>SNS 알림</li>
                                </ul>
                                <ul className="realtimeTableTd" key='NH3'>
                                    <li>암모니아</li>
                                    <li>
                                        <input
                                            id="modifyMoeLimitNH3"
                                            name="modifyMoeLimitNH3"
                                            value={modifyMoeLimitNH3}
                                            ref={focusRefModifyMoeLimitNH3}
                                            onChange={handleChangeModifyAlert}
                                            className="textInputSettingAlert"
                                            type="text"
                                            placeholder=""
                                            maxLength={5} />
                                    </li>
                                    <li>
                                        <input
                                            id="modifyUserLimitNH3"
                                            name="modifyUserLimitNH3"
                                            value={modifyUserLimitNH3}
                                            ref={focusRefModifyUserLimitNH3}
                                            onChange={handleChangeModifyAlert}
                                            className="textInputSettingAlert"
                                            type="text"
                                            placeholder=""
                                            maxLength={5} />
                                    </li>
                                    <li>
                                        <Checkbox
                                            {...label}
                                            checked={checkedLightLampNH3}
                                            onChange={handleChange_LightLamp_NH3}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                        />
                                    </li>
                                    <li>
                                        <Checkbox
                                            {...label}
                                            checked={checkedSNSPushNH3}
                                            onChange={handleChange_SNSPush_NH3}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                        />
                                    </li>
                                </ul>
                                <ul className="realtimeTableTd" key='H2S'>
                                    <li>황화수소</li>
                                    <li>
                                        <input
                                            id="modifyMoeLimitH2S"
                                            name="modifyMoeLimitH2S"
                                            value={modifyMoeLimitH2S}
                                            ref={focusRefModifyMoeLimitH2S}
                                            onChange={handleChangeModifyAlert}
                                            className="textInputSettingAlert"
                                            type="text"
                                            placeholder=""
                                            maxLength={5} />
                                    </li>
                                    <li>
                                        <input
                                            id="modifyUserLimitH2S"
                                            name="modifyUserLimitH2S"
                                            value={modifyUserLimitH2S}
                                            ref={focusRefModifyUserLimitH2S}
                                            onChange={handleChangeModifyAlert}
                                            className="textInputSettingAlert"
                                            type="text"
                                            placeholder=""
                                            maxLength={5} />
                                    </li>
                                    <li>
                                        <Checkbox
                                            {...label}
                                            checked={checkedLightLampH2S}
                                            onChange={handleChange_LightLamp_H2S}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                        />
                                    </li>
                                    <li>
                                        <Checkbox
                                            {...label}
                                            checked={checkedSNSPushH2S}
                                            onChange={handleChange_SNSPush_H2S}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                        />
                                    </li>
                                </ul>
                            </div>
                            <div className="settingLayoutBody1Btn">
                                <Button style={{backgroundColor: '#4e82eb' , borderRadius:'8px' , margin: '0 16px' , padding: '6px 64px', border: 'none' , color:'white'}}
                                        onClick={handleModifySubmitAlert}
                                        variant="outlined">
                                        수 정
                                </Button>
                            </div>
                        </div>
                        <div className="setting-layout-2_2">
                            <div className="setting-layout-header">
                                <h3>측정 간격 설정</h3> <span>Setting the Measurement Interval</span>
                            </div>
                            <div className="settingLayoutBody3">
                                <ul className="realtimeTableTh">
                                    <li>항목</li>
                                    <li>축산환경관리원 전송 간격 (분)</li>
                                    {/* <li>사용자 측정 간격</li> */}
                                    <li>측정치 반영 시간</li>
                                </ul>
                            {
                                deviceListInfo &&
                                deviceListInfo.map((deviceInfo, index) => (
                                    deviceInfo.sensorId && deviceInfo.sensorId.length === 16 && (
                                        <ul className="realtimeTableTd" key={`device-${index}`}>
                                            <li>{deviceInfo.sensorNumber}</li>
                                            <li>{settingInfo.livestockTerm}</li>
                                            <li className="comboBox">
                                                <Box sx={{ maxWidth: 80 }}>
                                                    <FormControl fullWidth>
                                                        <NativeSelect
                                                            id='modifyUserTerm'
                                                            name='modifyUserTerm'
                                                            value={modifyUserTerm}
                                                            inputProps={{
                                                                name: '',
                                                                id: 'uncontrolled-native',
                                                            }}
                                                            onChange={handleChangeModifyTerm}
                                                        >
                                                            <option value={10}>10초</option>
                                                            <option value={30}>30초</option>
                                                            <option value={60}>1분</option>
                                                            <option value={60 * 5}>5분</option>
                                                            <option value={60 * 10}>10분</option>
                                                            <option value={60 * 15}>15분</option>
                                                            <option value={60 * 20}>20분</option>
                                                            <option value={60 * 25}>25분</option>
                                                            <option value={60 * 30}>30분</option>
                                                        </NativeSelect>
                                                    </FormControl>
                                                </Box>
                                            </li>
                                        </ul>
                                    )
                                ))
                            }
                            </div>
                            <div className="settingLayoutBody1Btn">
                                <Button style={{backgroundColor: '#4e82eb' , borderRadius:'8px' , margin: '0 16px' , padding: '6px 64px', border: 'none' , color:'white'}}
                                        onClick={handleModifySubmitTerm}
                                        variant="outlined">
                                        수 정
                                </Button>
                            </div>
                        </div>
                    </div>
                    </>
                }
                </div>
            </div>
        </div>
    )
}

export default Setting;
